import React from 'react';
import MatrixBackground from './MatrixBackground';

function AboutPage() {
  return (
    <div className="matrix-background">
      <MatrixBackground />
      <div className="matrix-content">
        <h1 className="text-4xl md:text-6xl font-bold text-green-400 mb-6">О нас</h1>
        <p className="text-lg md:text-xl text-green-300 max-w-2xl mx-auto text-center">
          Мы создаём будущее уже сегодня. Наша команда состоит из разработчиков, дизайнеров и мечтателей.
        </p>
        <button 
          className="mt-8 px-6 py-3 rounded-full bg-green-500 hover:bg-green-600 text-black font-semibold transition-all"
          onClick={() => window.history.back()}
        >
          Назад
        </button>
      </div>
    </div>
  );
}

export default AboutPage;